<template>
  <BaseOverlay
    :show="loading"
  >
    <TransitionBusinessModal
      :entity="transitionBusinessData.business"
      :action="transitionBusinessData.action"
      entity-type="Branch"
      @transition-applied="fetchBusinessBranches"
    />
    <b-modal
      id="create-branch-modal"
      :title="`${toBeUpdatedBranch ? 'Update Branch' : 'New branch'}`"
      hide-footer
      @hidden="toBeUpdatedBranch = undefined"
    >
      <CreateBranch
        :branch="toBeUpdatedBranch"
        :business-id="businessId"
        @refetch="fetchBusinessBranches"
      />
    </b-modal>
    <b-card>
      <b-card-title class="d-flex align-items-center justify-content-between">
        <h3>Branches</h3>
        <div>
          <b-button
            variant="primary"
            @click="openCreateBranchModal"
          >
            Create new Branch
          </b-button>

        </div>
      </b-card-title>
      <b-table
        striped
        :items="list"
        :fields="tableColumns"
        show-empty
        empty-text="Empty"
      >

        <template #cell(actions)="data">
          <b-button
            v-if="data.item.state === 'IN_REVIEW'"
            class="btn-icon rounded-circle"
            variant="flat-success"
            @click="transitionBusinessHandler(data.item, 'APPROVE')"
          >
            <feather-icon
              size="20"
              icon="CheckIcon"
            />
          </b-button>
          <b-button
            v-if="data.item.state === 'IN_REVIEW'"
            class="btn-icon rounded-circle"
            variant="flat-danger"
            @click="transitionBusinessHandler(data.item, 'REJECT')"
          >
            <feather-icon
              size="20"
              icon="XIcon"
            />
          </b-button>
          <b-button
            class="btn-icon rounded-circle"
            variant="flat-primary"
            @click="updateBranchModalHandler(data.item)"
          >
            <feather-icon
              size="20"
              icon="EditIcon"
            />
          </b-button>

        </template>
      </b-table>
    </b-card>
  </BaseOverlay>
</template>

<script>
import {
  BCard, BCardTitle, BButton, BTable, BModal,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import formatDate from '@/utils/date-format'
import CreateBranch from './CreateBranch.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import TransitionBusinessModal from './TransitionBusinessModal.vue'

export default {
  components: {
    BCard, BCardTitle, BaseOverlay, BButton, BTable, BModal, CreateBranch, TransitionBusinessModal,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const tableColumns = [
      {
        label: 'Name',
        key: 'name',
        formatter: val => val.en,
      },
      {
        label: 'Phone No',
        key: 'phoneNumber',
      },
      {
        label: 'created at',
        key: 'createdAt',
        formatter: val => formatDate(val),
      },
      {
        label: 'State',
        key: 'state',
        formatter: val => snakeCaseToCamelCase(val),
      },
      'actions',
    ]
    const list = ref([])
    const loading = ref(false)
    const fetchBusinessBranches = async () => {
      try {
        loading.value = true
        const result = await ctx.root.$store.dispatch('business/getBusinessBranch', props.businessId)
        const { data } = result.data.data
        list.value = data
      } finally {
        loading.value = false
      }
    }

    fetchBusinessBranches()

    const openCreateBranchModal = () => ctx.root.$bvModal.show('create-branch-modal')

    const transitionBusinessData = ref({
      business: {},
      action: 'APPROVE', // APPROVE || REJECT
    })

    const transitionBusinessHandler = (business, action) => {
      transitionBusinessData.value.business = { ...business }
      transitionBusinessData.value.action = action
      ctx.root.$bvModal.show('transition-business-modal')
    }

    const toBeUpdatedBranch = ref(undefined)
    const updateBranchModalHandler = branch => {
      toBeUpdatedBranch.value = JSON.parse(JSON.stringify(branch))
      ctx.root.$bvModal.show('create-branch-modal')
    }
    return {
      loading,
      list,
      updateBranchModalHandler,
      fetchBusinessBranches,
      tableColumns,
      openCreateBranchModal,
      transitionBusinessHandler,
      transitionBusinessData,
      toBeUpdatedBranch,
    }
  },
}
</script>

<style>

</style>
